/**
 *
 * AuthApp.react.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. header)
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AuthRoutes, config } from 'hub-redux-auth';
import Footer from '../../components/Footer';


function AuthApp(props) {
  const { match, history, location } = props;
  return (
    <div>
      <div className="page-container">
        <div className="page-container-inner fonts-wrap grey-background">
          <AuthRoutes match={match} history={history} />
        </div>
        {
          config.get('disableOnboarding') && location?.pathname == '/account/signup' ? null : <Footer />
        }
      </div>
    </div>
  );
}

AuthApp.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
  children: PropTypes.node,
  product: PropTypes.string,
};

export default connect(state => ({ product: state.product }))(AuthApp);
